import React from 'react'

import { Disclosure } from '@headlessui/react'
import { PlusCircledIcon } from '@radix-ui/react-icons'
import { tx } from '@twind/core'

const FaqComponent = ({
  faqs
}: {
  faqs: { question: string; answer: string; id: number }[]
}) => {
  return (
    <dl className="w-full">
      {faqs.map((faq, index) => (
        <Disclosure as="div" key={faq.id} className="">
          {({ open }) => (
            <div className={tx('py-5', open ? 'bg-[#EBF0F7]' : 'bg-[#F4F7FB]')}>
              <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:max-w-screen-2xl lg:px-8 text-2xl w-full">
                <dt>
                  <Disclosure.Button className="text-left w-full flex justify-between items-start focus:outline-none">
                    <div className="font-medium text-[#242222] text-base md:text-xl lg:text-2xl">
                      <span className="font-bold text-[#9D96A8]">
                        {(index + 1).toString().padStart(2, '0')}
                      </span>
                      <span className="mx-3">{faq.question}</span>
                    </div>
                    <span className="ml-6 h-7 flex items-center">
                      <PlusCircledIcon
                        className={tx(
                          'h-8 w-8 transition-transform transition-colors',
                          open ? 'rotate-45 text-indigo-900' : 'rotate-0'
                        )}
                        aria-hidden="true"
                      />
                    </span>
                  </Disclosure.Button>
                </dt>

                <Disclosure.Panel as="dd" className="mt-2 pl-10">
                  <div className="text-base md:text-lg lg:text-xl text-[#656565]">
                    {faq.answer}
                  </div>
                </Disclosure.Panel>
              </div>
            </div>
          )}
        </Disclosure>
      ))}
    </dl>
  )
}

export default FaqComponent
